import { ClientRouteOptions, TypedClientAjaxProxy } from "@cervval.js/client-html5-spa/routes";
import { ActionPersistData, ActionPersistResult } from "@cervval.js/common-action/src/action.model";
import { ActionRoutes } from "@cervval.js/common-action/src/routes/actions.route";
import { ACTION_PERSISTENCE_SERVICE, ActionPersistenceService } from "@cervval.js/common-action/src/services/actionPersistence.service";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";

@Injectable(ACTION_PERSISTENCE_SERVICE)
export class ClientActionPersistenceService<Context = void> implements ActionPersistenceService<Context> {

    @TypedClientAjaxProxy()
    public actionRoutes!: ActionRoutes<ClientRouteOptions, Context>;

    /**
     * Send the action persist data list to the server.
     * Does not show hourglass by default, if you use waitForReply you will need to manage hourglass yourself.
     * @param actionPersistDataArray
     * @returns {Promise<ActionPersistResult>}
     */
    public persistActionData(actionPersistDataArray: ActionPersistData<Context>[]): Promise<ActionPersistResult[]> {
        return this.actionRoutes.persistActionData({ actionPersistDataArray }, { showHourGlass: false });
    }

}